import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { AtomsModule } from '@library/ui/atoms/atoms.module';
import { LayoutModule } from '@library/ui/layout/layout.module';
import { IllustratedPageComponent } from './illustrated-page.component';

@NgModule({
  declarations: [
    IllustratedPageComponent,
  ],
  exports: [
    IllustratedPageComponent,
  ],
  imports: [
    CommonModule,
    AtomsModule,
    LayoutModule,
  ],
})
export class IllustratedPageModule {}